import {toast, toasterActions} from '@homeaway/react-toaster';

function triggerChatExitToast(store, action = {payload: {}}) {
    const {element, onClose} = action.payload;

    const exitToast = toast(element, {
        autoClose: 15000,
        onClose,
        type: 'inverse'
    });

    store.dispatch(toasterActions.addToast(exitToast));
}

export {triggerChatExitToast};
